// extracted by mini-css-extract-plugin
module.exports = {"content":"defensiveStats_content__XycOG","notLoadedContainer":"defensiveStats_notLoadedContainer__E567A"};